// Shared auth-screen canvas — faithful to the validated wireframes (UniTicket
// glass card + animated Unifiber gradient), elevated with a film-grain overlay
// and staggered reveals. Used by every pre-auth screen.
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function AuthShell({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-dvh animated-gradient-bg grain-overlay relative flex">
      {/* Top-left: Unifiber logo (diapositive on gradient, per brand rules) */}
      <div className="absolute top-4 left-4 sm:top-8 sm:left-10 z-10">
        <img src="/UnifiberLogoWhite.png" alt="Unifiber" className="h-8 sm:h-12 opacity-90" />
      </div>

      {/* Left: product wordmark (desktop) */}
      <div className="hidden lg:flex lg:w-[50%] relative z-10 flex-col justify-center items-start pl-20 pr-12">
        <h1 className="text-white text-7xl font-bold tracking-tight drop-shadow-lg animate-fade-up">
          UniPortal
        </h1>
        <p className="mt-4 text-white/70 text-lg font-light tracking-wide animate-fade-up [animation-delay:0.12s]">
          Unifiber external document portal
        </p>
      </div>

      {/* Right: glass card */}
      <div className="flex-1 flex items-start sm:items-center justify-center relative z-10 px-6 pt-20 pb-6 sm:py-12">
        <div
          className={`glass-card-login rounded-2xl p-6 sm:p-10 w-full space-y-6 stagger ${
            wide ? 'max-w-xl' : 'max-w-md'
          }`}
        >
          {/* Mobile wordmark */}
          <div className="lg:hidden text-center mb-4">
            <h2 className="text-3xl font-bold text-white drop-shadow">UniPortal</h2>
          </div>
          {children}
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="absolute bottom-6 left-0 right-0 text-center z-10 pointer-events-none">
        <p className="text-white/25 text-xs">{t('copyright', { year: new Date().getFullYear() })}</p>
      </div>
    </div>
  );
}
